module.exports = __webpack_public_path__ + "static/media/lv.f3c1274d.svg";